export const createCompanyConfig = (data) => {
    if (!assertCompanyConfig(data, "save")) {
        throw new Error("CompanyConfig.save failed");
    }
    return data;
};
export function assertCompanyConfig(companyConfig, mode = "load") {
    if (!companyConfig || typeof companyConfig !== "object") {
        throw new Error("CompanyConfig must be an object");
    }
    return true;
}
export const createCompanyConfigConverter = (convertToFirestoreTimestampOrDefaultServerTime) => ({
    toFirestore(companyConfig) {
        if (!assertCompanyConfig(companyConfig, "save")) {
            throw new Error("CompanyConfig.save failed");
        }
        const { id, ...companyConfigWithoutId } = companyConfig;
        const data = {
            ...companyConfigWithoutId,
            apiVersion: 1,
        };
        return data;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        if (!data)
            throw new Error("Snapshot doesn't contain data");
        const companyConfig = {
            ...data,
            id: snapshot.id,
        };
        if (!assertCompanyConfig(companyConfig)) {
            throw new Error("CompanyConfig.load failed");
        }
        return companyConfig;
    },
});
//# sourceMappingURL=CompanyConfig.js.map